import { parseISO, format, eachDayOfInterval, isSameDay, isValid, parse } from 'date-fns';

/**
 * Mappe les événements API vers le format FullCalendar.
 * Toutes les occurrences sont allDay + list-item : FullCalendar n'utilise
 * alors plus les blocs fc-h-event (hauteur trop grande) ni le timeGrid.
 */
function normalizeEvents(events) {
  if (Array.isArray(events)) {
    return events;
  }

  if (Array.isArray(events?.data)) {
    return events.data;
  }

  if (Array.isArray(events?.results)) {
    return events.results;
  }

  if (Array.isArray(events?.items)) {
    return events.items;
  }

  return [];
}

function parseEventDate(value) {
  if (!value) {
    return null;
  }

  const iso = parseISO(String(value).replace(' ', 'T'));
  if (isValid(iso)) {
    return iso;
  }

  const sql = parse(String(value), 'yyyy-MM-dd HH:mm:ss', new Date());
  if (isValid(sql)) {
    return sql;
  }

  const dayOnly = parse(String(value).slice(0, 10), 'yyyy-MM-dd', new Date());
  return isValid(dayOnly) ? dayOnly : null;
}

function buildExtendedProps(event) {
  return {
    slug: event.slug || event.id,
    categories: event.categories || [],
    originalStart: event.start,
    originalEnd: event.end,
  };
}

function toAllDayOccurrence(event, day, index = 0) {
  const dayStr = format(day, 'yyyy-MM-dd');
  return {
    id: `${event.id}-${dayStr}`,
    title: event.title,
    start: dayStr,
    allDay: true,
    display: 'list-item',
    extendedProps: {
      ...buildExtendedProps(event),
      occurrenceIndex: index,
    },
  };
}

function expandEventsForCalendar(events) {
  return normalizeEvents(events).flatMap((event) => {
    const startDate = parseEventDate(event?.start);
    const endDate = parseEventDate(event?.end) || startDate;

    if (!startDate || !endDate) {
      return [];
    }

    if (endDate < startDate) {
      return [];
    }

    if (isSameDay(startDate, endDate)) {
      return [toAllDayOccurrence(event, startDate, 0)];
    }

    return eachDayOfInterval({ start: startDate, end: endDate }).map((day, index) =>
      toAllDayOccurrence(event, day, index)
    );
  });
}

export default expandEventsForCalendar;
